import apiClient from "../config/apiClient";

export const sendLabRequest = async (id,requestType, items,note) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=requests/save-request`,
       {"patient_id":id,requestType, ...note, "tests":items, "overTheCounter":true}, 
       {
        headers: {
        Authorization: "Bearer " + token,
      },
    });
};